import React, { Component } from 'react';
import { Location } from '../../../../types/index';
import withStickyBehavior from '../../hoc/withStickyBehavior';
import './StickyTabs.scss';
import Tabs from './Tabs';

const NABVAR_HEIGHT = 72;

interface StickyTabsProps {
    items: {
        value: number;
        displayName?: React.ReactNode;
        content?: JSX.Element;
        isSelected?: boolean;
    }[];
    onTabChange?: Function;
    onTabLoad?: Function;
    initialSelectedTab?: string;
    location: Location;
    isNewHeader?: boolean;
}

class StickyTabs extends Component<StickyTabsProps> {
    render() {
        const {
            items,
            onTabChange,
            onTabLoad,
            initialSelectedTab,
            location,
            isNewHeader,
        } = this.props;

        return (
            <Tabs
                isNewHeader={isNewHeader}
                items={items}
                onTabChange={onTabChange}
                onTabLoad={onTabLoad}
                initialSelectedTab={initialSelectedTab}
                location={location}
            />
        );
    }
}

export default withStickyBehavior(StickyTabs, { topAdjust: NABVAR_HEIGHT });
